// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrustedDeviceRequestPopup__popup-a91087 {
  width: 100%;
  height: fit-content;
  flex: none;
  max-width: 440px;
}

.TrustedDeviceRequestPopup__wrapper-c6fb62 {
  overflow-y: auto;
  height: fit-content;
  width: 100%;
  background: var(--gradient-10);
  background-size: 100% 258px;
  background-repeat: no-repeat;
  padding: 24px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.TrustedDeviceRequestPopup__logo-f873ec {
  width: 120px;
  height: 120px;
}

.TrustedDeviceRequestPopup__title-f8f469 {
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-image: var(--gradient-0);
  font: var(--font-title-6);
  margin-top: 24px;
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 16px;
  text-align: center;
}

.TrustedDeviceRequestPopup__device-b50ac1 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-100);
  margin-bottom: 4px;
}

.TrustedDeviceRequestPopup__time-a46edd {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-100);
  margin-bottom: 16px;
}

.TrustedDeviceRequestPopup__bottom-description-a1f954 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-120);
  margin-bottom: 16px;
}

.TrustedDeviceRequestPopup__bottom-description-a1f954:last-child {
  margin-bottom: 24px;
}

.TrustedDeviceRequestPopup__approve-button-f4ca9e {
  width: 100%;
  margin-bottom: 8px;
}

.TrustedDeviceRequestPopup__block-button-cdb0d9 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/TrustedDeviceRequestPopup/TrustedDeviceRequestPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".popup {\n  width: 100%;\n  height: fit-content;\n  flex: none;\n  max-width: 440px;\n}\n\n.wrapper {\n  overflow-y: auto;\n  height: fit-content;\n  width: 100%;\n  background: var(--gradient-10);\n  background-size: 100% 258px;\n  background-repeat: no-repeat;\n  padding: 24px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo {\n  width: 120px;\n  height: 120px;\n}\n\n.title {\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  background-image: var(--gradient-0);\n  font: var(--font-title-6);\n  margin-top: 24px;\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.device {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-100);\n  margin-bottom: 4px;\n}\n\n.time {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-100);\n  margin-bottom: 16px;\n}\n\n.bottom-description {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-120);\n  margin-bottom: 16px;\n}\n\n.bottom-description:last-child {\n  margin-bottom: 24px;\n}\n\n.approve-button {\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.block-button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `TrustedDeviceRequestPopup__popup-a91087`,
	"wrapper": `TrustedDeviceRequestPopup__wrapper-c6fb62`,
	"logo": `TrustedDeviceRequestPopup__logo-f873ec`,
	"title": `TrustedDeviceRequestPopup__title-f8f469`,
	"device": `TrustedDeviceRequestPopup__device-b50ac1`,
	"time": `TrustedDeviceRequestPopup__time-a46edd`,
	"bottom-description": `TrustedDeviceRequestPopup__bottom-description-a1f954`,
	"bottomDescription": `TrustedDeviceRequestPopup__bottom-description-a1f954`,
	"approve-button": `TrustedDeviceRequestPopup__approve-button-f4ca9e`,
	"approveButton": `TrustedDeviceRequestPopup__approve-button-f4ca9e`,
	"block-button": `TrustedDeviceRequestPopup__block-button-cdb0d9`,
	"blockButton": `TrustedDeviceRequestPopup__block-button-cdb0d9`
};
module.exports = ___CSS_LOADER_EXPORT___;
